import { Icon, IconButton, Typography } from '@smartgift/frontend-toolkit';
import { useIsMutating } from '@tanstack/react-query';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

function NavigationEndContent({ children }) {
  const { t } = useTranslation();
  const mutatingCount = useIsMutating();

  const isLoading = mutatingCount > 0;

  return (
    <>
      <Typography
        as="div"
        variant="body2SemiBold"
        emphasis={isLoading ? '800' : '400'}
        style={{
          width: 175,
          justifyContent: 'flex-end',
          display: 'inline-flex',
          gap: 4,
          alignItems: 'center'
        }}
      >
        {children}
        {isLoading ? (
          <>
            <S.RotateAnimation
              animate={{ rotate: 180 }}
              transition={{ repeat: Infinity, duration: 1 }}
            >
              <Icon name="automation" />
            </S.RotateAnimation>
            {t('saving')}...
          </>
        ) : (
          <>
            <IconButton as="span" variant="outlined">
              <Icon name="success" />
            </IconButton>
            <Typography variant="body2" color="primary">
              {t('saved')}
            </Typography>
          </>
        )}
      </Typography>
    </>
  );
}

export { NavigationEndContent };
